<script>
export default {
  props: {
    next: {
      type: Function,
      required: true,
    },
    prev: {
      type: Function,
      required: true,
    },
  },
  created() {
    this.$touchEventData = {
      startX: 0,
      startY: 0,
      curX: 0,
      curY: 0,
      direction: 'none',
      startingDirection: null,
    }
  },
  methods: {
    touchStart(e) {
      const { x, y } = this.getCoordinates(e)

      this.$touchEventData = {
        startX: x,
        startY: y,
        curX: x,
        curY: y,
      }
    },
    touchMove(e) {
      const updatedTouchEventData = JSON.parse(
        JSON.stringify(this.$touchEventData),
      )
      const { x, y } = this.getCoordinates(e)
      updatedTouchEventData.curX = x
      updatedTouchEventData.curY = y

      const currentDirection = this.getCurrentDirection(
        updatedTouchEventData,
        this.$touchEventData,
        this.$touchEventData.startingDirection,
      )
      const swipeDirection = this.getSwipeDirection(updatedTouchEventData)

      this.$touchEventData = {
        ...updatedTouchEventData,
        direction: currentDirection || swipeDirection,
        startingDirection:
          this.$touchEventData.startingDirection || swipeDirection,
      }
    },
    touchEnd() {
      const { startingDirection, direction } = this.$touchEventData

      if (direction === 'vertical' || startingDirection !== direction) {
        this.$touchEventData.direction = 'none'
        this.$touchEventData.startingDirection = null
      }

      if (direction === 'right') this.next()
      if (direction === 'left') this.prev()
    },
    getSwipeDirection(touchEventData) {
      const xDist = touchEventData.startX - touchEventData.curX
      const yDist = touchEventData.startY - touchEventData.curY

      if (Math.abs(xDist) > Math.abs(yDist)) {
        if (xDist > 0) return 'right'
        return 'left'
      }

      return 'vertical'
    },
    getCurrentDirection(touchEventData, prevTouchEventData, startingDirection) {
      if (startingDirection === 'vertical' || !startingDirection) return null
      if (touchEventData.curX - prevTouchEventData.curX < 0) return 'right'
      return 'left'
    },
    getCoordinates(event) {
      const hasTouchesArray = event.touches && event.touches.length
      const x = hasTouchesArray ? event.touches[0].pageX : event.clientX
      const y = hasTouchesArray ? event.touches[0].pageY : event.clientY

      return { x, y }
    },
  },
}
</script>

<template>
  <div
    @touchstart.passive="touchStart"
    @touchmove.passive="touchMove"
    @touchend.passive="touchEnd"
  >
    <slot></slot>
  </div>
</template>
